import React from "react";
import { BiSearch } from "react-icons/bi";
import { twMerge } from "tailwind-merge";

import TextInput from "@/ui/text-input";

type SearchInputProps = React.InputHTMLAttributes<HTMLInputElement>;

const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, ...rest }, ref) => {
    return (
      <div className={twMerge("relative", className)}>
        <BiSearch
          size="1.1em"
          className="absolute left-3.5 top-1/2 -translate-y-1/2 text-ink-muted pointer-events-none"
        />
        <TextInput ref={ref} type="search" className="pl-10" {...rest} />
      </div>
    );
  }
);

SearchInput.displayName = "SearchInput";

export default SearchInput;
